/* eslint-disable no-console */
import { httpModule } from '@shared/http';

export type Bank = {
    id: number;
    description: string;
    name: string;
    bcra_code: string;
    country_id: number;
};

export async function fetchBanks(page?: number, limit?: number, search?: string) {
    try {
        return await httpModule.get('/bank', {
            params: { page, limit, search }
        });
    } catch (ex) {
        console.warn(`Error fetching banks: ${ex}`);
    }
}

export async function patchBankAccountStatus(
    id: number,
    cbu: string,
    cuit: string,
    holderName: string,
    bank: number,
    accountType?: 'SavingsAccount' | 'CheckingAccount',
    isDefault?: boolean,
    propietorAccount?: number
) {
    try {
        return await httpModule.patch('/bank-account', {
            id,
            cbu,
            cuit,
            holderName,
            bank,
            accountType,
            isDefault,
            propietorAccount
        });
    } catch (ex) {
        console.warn('Error updating bankAccounts Status');
        console.log(ex.response);
    }
}